<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="管理人员">
          <el-select v-model="formData.opIds" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in OPTIONS_OPDATA" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="开户主体">
          <el-select v-model="formData.companyId" filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in OPTIONS_COMPANYDATA" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-input
            style="width: 214px"
            v-model="formData.keyWords"
            class="plan-input"
            clearable
            @keyup.enter.native="searchEvent"
            @clear="searchEvent"
            placeholder="请输入账号名称/账号简称"
          />
        </ElFormItem>
        <el-button type="primary" @click="searchEvent" :loading="tableLoading">查询</el-button>
        <el-button type="text" @click="batchAdd">批量添加</el-button>
      </ElForm>
      <div class="c-submit">
        <el-row :gutter="12">
          <el-col :span="16">
            <el-table
              v-loading="tableLoading"
              ref="ref_MultipleTable"
              height="492"
              border
              :data="accountList"
              style="width: 100%"
              @row-click="onTableRowClick"
              @select="onSelectChange"
              @select-all="onSelectAllChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column prop="adAccount" label="账号名称" width="180"> </el-table-column>
              <el-table-column prop="adAccountSimpleName" label="账号简称" width="120"> </el-table-column>
              <el-table-column prop="companyName" label="开户主体"> </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageInfo.current"
                :pager-count="5"
                :page-sizes="[10, 20, 30, 40]"
                :page-size.sync="pageInfo.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageInfo.total"
              >
              </el-pagination>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="add-box">
              <div class="flex flex-between pr-10">
                <span>已添加({{ selectList.length }})</span>
                <el-button type="text" @click="batchClear">清空全部</el-button>
              </div>
              <div class="item-group">
                <div class="flex flex-between" v-for="(item, index) in selectList" :key="item.id">
                  <span>{{ item.adAccount }}</span>
                  <el-button type="text" icon="el-icon-close" @click="toggleSelection(item, index)"></el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="saveData">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog append-to-body title="批量添加账号" :visible.sync="_dialogVisible" width="500px">
      <ElForm :model="ruleForm" :rules="rules" ref="ref_RuleForm" v-highlight>
        <ElFormItem prop="content">
          <el-input
            :rows="8"
            type="textarea"
            v-model="ruleForm.content"
            class="plan-input"
            placeholder="每行一个账号名称（通过回车换行），只能导入自己有管理权限的账号"
          />
        </ElFormItem>
      </ElForm>
      <div>已输入账号{{ accountLen }}/200</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="_close()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
import { reactive, ref, onMounted, nextTick, inject, computed } from 'vue'
import { MEDIAS } from '@/common/js/constants.js'
import { isArray } from '@/common/js/utils'
import { queryCompanyList, queryAccountPageNew, checkAccount } from '@/api/sysmana.model'
import { adPtom } from '@/api/common.model'
import { MessageBox } from 'element-ui'
import { useAccountTable } from './useAccountSelector.js'
// eslint-disable-next-line
const { title, mediaId } = defineProps({
  title: String,
  mediaId: {
    type: Number,
    default: MEDIAS.TOUTIAO
  }
})
const { configForm } = inject('configForm')
const { opId } = inject('localStates')
// eslint-disable-next-line
const emits = defineEmits(['saveData'])
const OPTIONS_OPDATA = ref([])
const OPTIONS_COMPANYDATA = ref([])
const dialogVisible = ref(false)
const _dialogVisible = ref(false)
const ruleForm = reactive({
  content: ''
})
const tableLoading = ref(false)
const ref_RuleForm = ref(null)
const rules = {
  content: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    {
      validator(rule, value, callback) {
        if (value.split(/\n/).length > 200) return callback(new Error('最多只能添加200个账号'))
        callback()
      }
    }
  ]
}
const columns = [
  {
    type: 'selection',
    width: 60,
    align: 'center'
  },
  {
    key: 'adAccount',
    title: '账号名称',
    width: 180
  },
  {
    key: 'createOpName',
    title: '管理人员',
    width: 180
  },
  {
    key: 'adAccountSimpleName',
    title: '账号简称',
    width: 120
  },
  {
    key: 'companyName',
    title: '开户主体'
  }
]
const accountLen = computed(() => {
  const conStr = ruleForm.content
  return !conStr ? 0 : conStr.split(/\n/).length
})
const formData = reactive({
  user: [],
  account: [],
  keyWords: '',
  companyId: undefined,
  opIds: [opId]
})
const pageInfo = reactive({
  current: 1,
  size: 10,
  total: 0
})

const { ref_MultipleTable, accountList, selectList, selectedIds, onTableRowClick, onSelectChange, onSelectAllChange, initCheckStates } =
  useAccountTable()

const batchAdd = () => {
  _dialogVisible.value = true
}
const batchClear = () => {
  selectList.value = []
  nextTick(initCheckStates)
}
const open = () => {
  dialogVisible.value = true
  selectList.value = configForm.value.accounts
  getData({
    pageIndex: 1,
    pageSize: 10,
    mediaIds: [mediaId],
    opIdList: formData.opIds
  })
}
const close = () => {
  dialogVisible.value = false
  formData.keyWords = ''
  formData.companyId = ''
  formData.opIds = [opId]
}
const _close = () => {
  ref_RuleForm.value.resetFields()
  _dialogVisible.value = false
}
const saveData = () => {
  close()
  emits('saveData', selectList.value)
}
const submitForm = () => {
  ref_RuleForm.value.validate((valid) => {
    if (valid) {
      _saveData()
    }
  })
}
const _saveData = async () => {
  const adAccountList = []
  ruleForm.content.split(/\n/).map((item) => {
    adAccountList.push(item.trim())
  })
  const result = await checkAccount({
    adAccountList,
    mediaId
  })
  const successList = []
  const msgs = []
  result.map((mp) => {
    if (!mp.id) {
      msgs.push(mp)
    } else {
      if (selectedIds.value.includes(mp.id)) {
        msgs.push({ ...mp, error: '重复账号' })
      } else {
        successList.push(mp)
      }
    }
  })
  const successIds = successList.map((fl) => fl.id)
  selectList.value = [
    ...selectList.value,
    ...successList.map((fl) => {
      return { id: fl.id, adAccount: fl.name }
    })
  ]
  nextTick(initCheckStates)
  if (msgs.length > 0) {
    const total = [{ name: '总计', error: `成功${successList.length}个,失败${msgs.length}个,失败明细如下:` }]
    MessageBox.alert([...total, ...msgs].map((ms) => `${ms.name}:${ms.error}<br>`).join(''), {
      title: '批量添加结果',
      confirmButtonText: '知道了',
      dangerouslyUseHTMLString: true
    })
  }
  _close()
}

const buildParams = () => {
  const params = {
    pageIndex: pageInfo.current,
    pageSize: pageInfo.size,
    keyword: formData.keyWords,
    opIdList: formData.opIds,
    mediaId
  }

  if (formData.companyId) params.companyId = formData.companyId

  return params
}

const handleSizeChange = (size) => {
  getData(buildParams())
}
const handleCurrentChange = (current) => {
  getData(buildParams())
}
const searchEvent = () => {
  getData(buildParams())
}

const getData = async (params) => {
  try {
    tableLoading.value = true
    const { list, page_info } = await queryAccountPageNew(params)
    accountList.value = list

    pageInfo.total = page_info.total_number
    tableLoading.value = false
    nextTick(initCheckStates)
  } catch (e) {
    tableLoading.value = false
  }
}
const preload = () => {
  Promise.all([adPtom({ authFlag: 1 }), queryCompanyList()])
    .then((data) => {
      const [opData, companyData] = data
      if (isArray(opData)) {
        OPTIONS_OPDATA.value = opData.map((i) => ({ ...i, id: i.opId }))
      }
      if (isArray(companyData)) {
        OPTIONS_COMPANYDATA.value = companyData.map((ret) => {
          return {
            id: ret.id,
            name: ret.companyName
          }
        })
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
const toggleSelection = (row, index) => {
  selectList.value.splice(index, 1)
  nextTick(initCheckStates)
}
onMounted(() => {
  preload()
})
// eslint-disable-next-line
defineExpose({
  open,
  close
})
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  &-between {
    justify-content: space-between;
  }
}
.pr-10 {
  padding-right: 10px;
}
.add-box {
  font-size: 12px;
  padding: 4px 0px 4px 10px;
  border: 1px solid #dfe6ec;
  border-radius: 2px;
  .item-group {
    padding-right: 10px;
    height: 450px;
    overflow: auto;
  }
}
.pagination-box {
  margin-top: 10px;
}
::v-deep .el-dialog__body {
  padding: 20px;
}
</style>
